import { toNumber } from "lodash"

export function safeDivide(dividend: number, divisor: number) {
  if (!dividend || !divisor) {
    return 0
  } else {
    return dividend / divisor
  }
}

export function limitPrecision(number: number, precision = 6) {
  return toNumber(Number(number).toFixed(precision))
}
